import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {Button} from "antd";
import {ArrowLeftOutlined, PhoneOutlined} from '@ant-design/icons'
import BranchMap from "./BranchMap";
import {DIR_RTL} from "../../../constants/ThemeConstant";
import {useDispatch, useSelector} from "react-redux";
import { selectBranch } from 'redux/actions';
import { weeks } from 'utils/estimated';

function BranchItem() {
    const {id} = useParams()
    const {theme:{direction}, fetchedData: {selectedBranch}} = useSelector(state => state)
    const history = useHistory()
    const [lat, setLat] = useState(0)
    const [lng, setLng] = useState(0)
    const dispatch = useDispatch()

    useEffect(()=>{
        navigator.geolocation.getCurrentPosition(function(position) {
            setLat(position.coords.latitude)
            setLng(position.coords.longitude)
        });
        dispatch(selectBranch(id))
    }, [])

    const date = new Date(Date.now())

    function isTodayExists(){
        for (let i = 0; i < selectedBranch?.pickupTiming?.length; i++) {
            if (selectedBranch?.pickupTiming[i]?.day?.toLowerCase() === weeks[date.getDay()].toLowerCase() || selectedBranch?.pickupTiming[i]?.day?.toLowerCase()==='everyday'){
                if (selectedBranch?.pickupTiming[i]?.closingTime > date.toLocaleTimeString('it-IT')){
                    return selectedBranch?.pickupTiming[i]?.closingTime
                }
            }
        }
        return false;
    }
    
    const orderClick = () => {
        if (isTodayExists()){
            localStorage.setItem('selected-mode','pickup')
            localStorage.setItem('selected-branch', JSON.stringify(selectedBranch))
            history.push('/app/menu')
        }
    }

    return (
        <div className="branchItemContainer d-flex flex-column">
            <div className='mx-3 py-2 h-100'>
                <div className=" py-2 border-bottom">
                    <h3 onClick={() => history.goBack()} className='order-mode__prev border-0 text-center'>
                        Branch Details
                        <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0}/>
                    </h3>
                </div>
                <BranchMap lat={selectedBranch?.lat} lng={selectedBranch?.lng}/>
                <div className="d-flex justify-content-center mb-4">
                    <Button className='btn-project-white mr-3' icon={<PhoneOutlined/>}>
                        <a target='_blank' rel="noreferrer" className='text-black ml-2' href={"tel://"+(selectedBranch?.phone?.startsWith("+")?selectedBranch?.phone:'+'+selectedBranch?.phone)}>Call Branch</a>
                    </Button>
                    <a href={`http://maps.google.com/maps?z=12&t=m&daddr=loc:${selectedBranch?.lat}+${selectedBranch?.lng}&saddr=loc:${lat}+${lng}`} target="_blank" rel="noreferrer" >
                    {/* <a href={`http://maps.google.com/maps?z=12&t=m&q=loc:${selectedBranch?.lat}+${selectedBranch?.lng}`} target="_blank" rel="noreferrer" > */}
                        <Button
                            className='text-white btn-project'
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <g>
                                        <g>
                                            <g>
                                                <path fill="#fff"
                                                    d="M15.77 7.434l-7.2-7.2a.8.8 0 0 0-1.128 0l-7.2 7.2a.8.8 0 0 0 0 1.132l7.2 7.2a.8.8 0 0 0 1.132 0l7.2-7.2a.8.8 0 0 0-.004-1.132zM9.605 10V8h-3.2v2.4h-1.6V7.2a.8.8 0 0 1 .8-.8h4v-2l2.8 2.8z"
                                                    transform="translate(.496) translate(3.496 4) translate(.007) translate(-.007)"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            }
                        >
                            Get Direction
                        </Button>
                    </a>
                </div>
                <div className={`${!isTodayExists()?'branch-status-false':'branch-status-true'} mb-5`}>
                    <span className="circle mr-1"></span>
                    {!isTodayExists() ? 'closed' : <>Open <span className='text-black mx-2'>until {isTodayExists()}</span></>}
                    
                </div>
                {
                    selectedBranch?.pickupTiming?.map(timing=><h4 className='d-flex align-items-center justify-content-between' style={{color: '#000'}}>
                        <span>{timing?.day}</span>
                        <span>{timing?.openingTime} - {timing?.closingTime}</span>
                    </h4>)
                }

            </div>
            <div className='orderCheckoutContainer branch-btn'>
                <Button onClick={orderClick} className={`w-100 orderCheckout btn-project primaryColor ${ !isTodayExists() ? 'disabledBranchButton ' : ''}`}>
                    {!isTodayExists()?'Currently closed':'Select As A Pickup Branch'}
                </Button>
            </div>
        </div>
    );
}

export default BranchItem;